import React from "react";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

const OwnerChangeDialogView = ({
    show,
    handleClose,
    companyManagers,
    handleCompanyOwnerSelectChange,
    handleChangeOwnerSubmit,
    errors,
    isSubmitting,
    handleShow
}) => {
    return (
        <>
            <Button onClick={handleShow} className="InviteUserBtn">
                Transfer Ownership
            </Button>
            <Modal show={show} onHide={handleClose} className="frmModalArea ModifyModal">
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <h5 className="h5Title mb-5">Change Company Owner</h5>
                    <Form className="formArea modifyModalForm">
                        <Row>
                            <Col md="12">
                                <Form.Group className="selectFieldBar" controlId="role">
                                    <Form.Label className="labelText">Company Managers</Form.Label>
                                    <Form.Select aria-label="company manager select" className="SelectField" name="owner_id" onChange={handleCompanyOwnerSelectChange}>
                                     <option value=''>Select Company Manager</option>
                                        {companyManagers
                                            ?.map((companyManager) => (
                                                <option value={companyManager?.id}>
                                                    {companyManager?.full_name}
                                                </option>
                                            ))}
                                    </Form.Select>
                                </Form.Group>
                                {errors?.owner_id && <p className="text-danger">{errors.owner_id}</p>}
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <div className="mdlFtBar ftBdr">
                                    <button className="fillPrimarBtn mrLauto  InviteBtn send " type="button" onClick={handleChangeOwnerSubmit} disabled={isSubmitting}>
                                        {isSubmitting ? 'Saving...' : 'Save'}
                                    </button>
                                </div>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default OwnerChangeDialogView;
